import { api } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';
import { getLastRewardDistributionDate } from 'modules/liquidStaking/methods/getLastRewardDistributionDate';

export const { useGetLastRewardDistributionDateQuery } = api.injectEndpoints({
  endpoints: build => ({
    getLastRewardDistributionDate: build.query<Date, void>({
      queryFn: async () => {
        const client = getPublicClient();

        return { data: await getLastRewardDistributionDate(client) };
      },
      providesTags: [],
    }),
  }),
});
